import * as React from "react";
import { forwardRef } from "react";
const TulipSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "m15.307 10.796 4.645-3.097a.5.5 0 0 1 .765.528l-1.368 5.927a7.542 7.542 0 0 1-14.698 0L3.283 8.227a.5.5 0 0 1 .765-.528l4.645 3.097a19.7 19.7 0 0 1 2.609-5.75l.426-.639a.326.326 0 0 1 .544 0l.426.64a19.7 19.7 0 0 1 2.61 5.749" }));
const ForwardRef = forwardRef(TulipSVG);
export default ForwardRef;
//# sourceMappingURL=Tulip.js.map